import { useEffect, useState } from 'react';
import { useRegisterSW } from 'virtual:pwa-register/react';
import { toast } from 'sonner';
import { Button } from '@/components/ui/button';
import { useOfflineQueue } from '@/hooks/useOfflineQueue';

export function ServiceWorkerRegistration() {
  const [showUpdatePrompt, setShowUpdatePrompt] = useState(false);
  const { syncQueue } = useOfflineQueue();

  const {
    offlineReady: [offlineReady, setOfflineReady],
    needRefresh: [needRefresh, setNeedRefresh],
    updateServiceWorker,
  } = useRegisterSW({
    onRegistered(registration) {
      console.log('Service Worker registered:', registration);
    },
    onRegisterError(error) {
      console.error('Service Worker registration error:', error);
    },
    onOfflineReady() {
      console.log('App ready to work offline');
      toast.success('App ready to work offline!', {
        description: 'You can now use BuildCRM without an internet connection.',
        duration: 5000,
      });
    },
    onNeedRefresh() {
      console.log('New content available');
      setShowUpdatePrompt(true);
    },
  });

  const handleUpdate = () => {
    updateServiceWorker(true);
    setShowUpdatePrompt(false);
  };

  const handleDismiss = () => {
    setShowUpdatePrompt(false);
    setOfflineReady(false);
    setNeedRefresh(false);
  };

  // Listen for background sync messages from service worker
  useEffect(() => {
    if ('serviceWorker' in navigator) {
      navigator.serviceWorker.addEventListener('message', (event) => {
        if (event.data?.type === 'PROCESS_OFFLINE_QUEUE') {
          console.log('Background sync triggered, processing queue...');
          syncQueue();
        }
      });
    }
  }, [syncQueue]);

  useEffect(() => {
    if (showUpdatePrompt) {
      toast(
        <div className="flex flex-col gap-2">
          <div className="font-semibold">New version available!</div>
          <div className="text-sm text-muted-foreground">
            Click update to get the latest features and improvements.
          </div>
          <div className="flex gap-2 mt-2">
            <Button size="sm" onClick={handleUpdate}>
              Update Now
            </Button>
            <Button size="sm" variant="outline" onClick={handleDismiss}>
              Later
            </Button>
          </div>
        </div>,
        {
          duration: Infinity,
          id: 'sw-update-prompt',
        }
      );
    }
  }, [showUpdatePrompt]);

  return null;
}
